import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpFromBracketThin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 448 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M229.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 27.3 216 344c0 4.4 3.6 8 8 8s8-3.6 8-8l0-316.7L354.3 149.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-136-136zM16 328c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-96c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 39.8-32.2 72-72 72L88 496c-39.8 0-72-32.2-72-72l0-96z" })
});
export default SvgArrowUpFromBracketThin;
